/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentDeliveryPlans } from 'app/entities/treatment-delivery-plan/treatment-delivery-plan.reducer';
import { getEntities as getTreatmentCycles } from 'app/entities/treatment-cycle/treatment-cycle.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-assessment.reducer';

export const TreatmentAssessmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentDeliveryPlans = useAppSelector(state => state.treatmentDeliveryPlan.entities);
  const treatmentCycles = useAppSelector(state => state.treatmentCycle.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const treatmentAssessmentEntity = useAppSelector(state => state.treatmentAssessment.entity);
  const loading = useAppSelector(state => state.treatmentAssessment.loading);
  const updating = useAppSelector(state => state.treatmentAssessment.updating);
  const updateSuccess = useAppSelector(state => state.treatmentAssessment.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-assessment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentDeliveryPlans({}));
    dispatch(getTreatmentCycles({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.assessmentDate !== undefined && typeof values.assessmentDate !== 'number') {
      values.assessmentDate = Number(values.assessmentDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentAssessmentEntity,
      ...values,
      plan: treatmentDeliveryPlans.find(it => it.id.toString() === values.plan?.toString()),
      cycle: treatmentCycles.find(it => it.id.toString() === values.cycle?.toString()),
      assessmentType: clinicalDictionaries.find(it => it.id.toString() === values.assessmentType?.toString()),
      assessmentResult: clinicalDictionaries.find(it => it.id.toString() === values.assessmentResult?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentAssessmentEntity,
          plan: treatmentAssessmentEntity?.plan?.id,
          cycle: treatmentAssessmentEntity?.cycle?.id,
          assessmentType: treatmentAssessmentEntity?.assessmentType?.id,
          assessmentResult: treatmentAssessmentEntity?.assessmentResult?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.treatmentAssessment.home.createOrEditLabel" data-cy="TreatmentAssessmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.treatmentAssessment.home.createOrEditLabel">
              Create or edit a TreatmentAssessment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-assessment-id"
                  label={translate('tinyMedicRestApp.treatmentAssessment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.assessmentDate')}
                id="treatment-assessment-assessmentDate"
                name="assessmentDate"
                data-cy="assessmentDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.active')}
                id="treatment-assessment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.cursor')}
                id="treatment-assessment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.lastUpdated')}
                id="treatment-assessment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.microSec')}
                id="treatment-assessment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentAssessment.timestampEntry')}
                id="treatment-assessment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-assessment-plan"
                name="plan"
                data-cy="plan"
                label={translate('tinyMedicRestApp.treatmentAssessment.plan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentDeliveryPlans
                  ? treatmentDeliveryPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-assessment-cycle"
                name="cycle"
                data-cy="cycle"
                label={translate('tinyMedicRestApp.treatmentAssessment.cycle')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentCycles
                  ? treatmentCycles.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-assessment-assessmentType"
                name="assessmentType"
                data-cy="assessmentType"
                label={translate('tinyMedicRestApp.treatmentAssessment.assessmentType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-assessment-assessmentResult"
                name="assessmentResult"
                data-cy="assessmentResult"
                label={translate('tinyMedicRestApp.treatmentAssessment.assessmentResult')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/treatment-assessment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentAssessmentUpdate;
